import { toast } from "react-toastify";
import { BillabilityUtilizationTarget } from "models/billability-utilization-target";
import BillabilityUtilizationTargetFields from "Components/organisms/forms/billability-utilization-target-form/types";

const BASE = `${process.env.REACT_APP_API_URL}/billability/targets`;

export const getBillabilityUtilizationTargets = async (): Promise<BillabilityUtilizationTarget[] | null> => {
    try {
        const res = await fetch(BASE, {
            credentials: 'include',
            method: 'GET',
        });

        if (!res.ok) {
            const errBody = await res.json();
            throw new Error(errBody.message);
        }

        const data = await res.json();
        return data.data as BillabilityUtilizationTarget[];
    } catch (err: any) {
        toast.error(err.message ?? "Error getting targets");
        return null;
    }
}

export const submitCreateBillabilityUtilizationTargetForm = async (
    vals: BillabilityUtilizationTargetFields
): Promise<BillabilityUtilizationTarget | null> => {
    try {
        const res = await fetch(BASE, {
            credentials: 'include',
            method: 'POST',
            body: JSON.stringify(vals),
            headers: {
                'Content-Type': 'application/json',
            }
        });

        if (!res.ok) {
            const errBody = await res.json();
            throw new Error(errBody.message);
        }

        toast.success("Target created.");
        const data = await res.json();
        return data.data;
    } catch (err: any) {
        toast.error(err.message ?? "Error creating target");
        return null;
    }
}

export const submitEditBillabilityUtilizationTargetForm = async (
    targetId: string,
    vals: BillabilityUtilizationTargetFields
): Promise<BillabilityUtilizationTarget | null> => {
    try {
        const res = await fetch(`${BASE}/${targetId}`, {
            credentials: 'include',
            method: 'PATCH',
            body: JSON.stringify(vals),
            headers: {
                'Content-Type': 'application/json',
            }
        });

        if (!res.ok) {
            const errBody = await res.json();
            throw new Error(errBody.message);
        }

        toast.success("Target updated.");
        const data = await res.json();
        return data.data;
    } catch (err: any) {
        toast.error(err.message ?? "Error editing target");
        return null;
    }
}

export const deleteBillabilityUtilizationTargetRequest = async (
    targetId: string
): Promise<boolean> => {
    try {
        const res = await fetch(`${BASE}/${targetId}`, {
            credentials: 'include',
            method: 'DELETE',
        });

        if (!res.ok) {
            const errBody = await res.json();
            throw new Error(errBody.message);
        }

        toast.success("Target deleted.");
        return true;
    } catch (err: any) {
        toast.error(err.message ?? "Error deleting target");
        return false;
    }
}
